
<div class="contact-title v-flex">
    <div
        v-if="length > 0"
        class="contact-badge primary--text"
    >
        {{ length }}
    </div>
    <div style="padding-top: 1px">
        {{ title }}
    </div>
    <div
        v-if="length > 1"
        style="margin-top: -3px"
    >
        <v-icon size="30" color="white">
            {{ menu ? "mdi-menu-up" : "mdi-menu-down" }}
        </v-icon>
    </div>
    <v-spacer />
    <slot name="right" />
</div>
